class FFCustomCart {
	id: string;
	type: string;
	k: string;
	working = false;

	DOM: {
		form: HTMLFormElement;
		validateButton: HTMLButtonElement;
		submitButton: HTMLButtonElement;
		emailInput: HTMLInputElement;
		section2: HTMLElement;
		dealerFields: HTMLElement;
		accountRadios: NodeListOf<HTMLInputElement>;
		accountFields: HTMLElement;
		shippingMethodSelect: HTMLSelectElement;
		spinner: HTMLElement;
	} = {} as FFCustomCart['DOM'];

	shippingOptions: Record<string, string[]> = {
		FedEx: [
			'FedEx 2Day',
			'FedEx 2Day A.M.',
			'FedEx Express Saver',
			'FedEx First Overnight',
			'FedEx Ground',
			'FedEx Ground Home Delivery',
			'FedEx International Economy',
			'FedEx International First',
			'FedEx International Priority',
			'FedEx Priority Overnight',
			'FedEx Standard Overnight',
		],
		UPS: [
			'UPS 2nd Day Air A.M.',
			'UPS 2nd Day Air',
			'UPS 3 Day Select',
			'UPS Next Day Air Saver',
			'UPS Next Day Air',
			'UPS Next Day Air Early A.M.',
			'UPS Saver',
			'UPS Worldwide Expedited',
			'UPS Worldwide Express Plus',
			'UPS Worldwide Express',
			'UPS Ground',
		],
	};

	constructor() {
		this.setVars();
		this.cache();
		if (!this.DOM.form) return;
		this.events();
	}

	setVars() {
		const urlParams = new URLSearchParams(window.location.search);
		const raId = urlParams.get('i');
		const documentId = urlParams.get('j');
		this.id = raId || documentId || '';
		this.type = raId ? 'RA' : 'SALES_DOCUMENT';
		this.k = urlParams.get('k') || '';
	}

	cache() {
		const form = document.querySelector('.js-customCartForm');
		if (!form) return;
		this.DOM = {
			form: form as HTMLFormElement,
			validateButton: form.querySelector('.js-validateButton') as HTMLButtonElement,
			submitButton: form.querySelector('.js-submitButton') as HTMLButtonElement,
			emailInput: form.querySelector('.js-emailInput') as HTMLInputElement,
			section2: form.querySelector('.js-section2') as HTMLElement,
			dealerFields: form.querySelector('.js-dealerFields') as HTMLElement,
			accountRadios: form.querySelectorAll('input[name=carrier]'),
			accountFields: form.querySelector('.js-accountFields') as HTMLElement,
			shippingMethodSelect: form.querySelector('.js-shippingMethodSelect') as HTMLSelectElement,
			spinner: form.querySelector('.js-spinner') as HTMLElement,
		};
	}

	events() {
		this.DOM.form.addEventListener('submit', this.formSubmit.bind(this));
		this.DOM.validateButton.addEventListener('click', this.validateClick.bind(this));
		this.DOM.emailInput.addEventListener('input', this.emailChange.bind(this));
		for (let i = 0; i < this.DOM.accountRadios.length; i++) {
			this.DOM.accountRadios[i].addEventListener('change', this.accountChange.bind(this));
		}
	}

	validateEmail(email: string) {
		if (email.length > 100) return;
		const split = email.split('@');
		if (split.length !== 2 || split[0] === '' || split[1] === '') {
			return false;
		}
		const domainSplit = split[1].split('.');
		const suffix = domainSplit[domainSplit.length - 1];
		if (domainSplit.length === 1 || suffix.length < 2) {
			return false;
		}
		return true;
	}

	emailChange(e: Event) {
		const input = e.currentTarget as HTMLInputElement;
		if (this.validateEmail(input.value)) {
			this.DOM.validateButton.disabled = false;
		} else {
			this.DOM.validateButton.disabled = true;
		}
	}

	accountChange(e: Event) {
		const val = (e.currentTarget as HTMLInputElement).value;
		if (val === '') {
			this.DOM.accountFields.classList.add('js-hide');
		} else {
			this.DOM.accountFields.classList.remove('js-hide');
			const options = this.shippingOptions[val] || [];
			const optionsHTML = `
        <option value="" selected>Select</option>
        ${options.map((el) => `<option value="${el}">${el}</option>`).join('')}
      `;
			this.DOM.shippingMethodSelect.innerHTML = optionsHTML;
			this.DOM.shippingMethodSelect.selectedIndex = 0;
		}
	}

	validateClick() {
		const email = this.DOM.emailInput.value;
		this.DOM.spinner.classList.remove('js-hide');

		const formData = new FormData();
		formData.append('action', 'custom_cart_validate');
		formData.append('id', this.id);
		formData.append('type', this.type);
		formData.append('email', email);
		if (this.k) formData.append('k', this.k);

		grecaptcha.ready(() => {
			grecaptcha.execute(RECAPTCHA_SITE_KEY, { action: 'submit' }).then((token: string) => {
				formData.append('g-recaptcha-response', token);
				try {
					fetch(ajaxurl, {
						method: 'POST',
						body: formData,
					})
						.then((response) => response.json())
						.then((data: { valid?: boolean; message?: string; isDealer?: boolean }) => {
							const valid = data.valid;
							if (!valid) {
								this.showErrorMessage(data.message || 'Validation failed.');
							} else {
								this.advance(data);
							}
							this.DOM.spinner.classList.add('js-hide');
						});
				} catch (error) {
					console.log(error);
					this.showErrorMessage(String(error));
					this.DOM.spinner.classList.add('js-hide');
				}
			});
		});
	}

	advance(data: { isDealer?: boolean }) {
		this.DOM.section2.classList.remove('js-hide');
		this.DOM.submitButton.classList.remove('js-hide');
		this.DOM.validateButton.classList.add('js-hide');
		if (data.isDealer) {
			this.DOM.dealerFields.classList.remove('js-hide');
		}
		this.DOM.submitButton.disabled = false;
	}

	formSubmit(e: SubmitEvent) {
		e.preventDefault();
		if (this.working) return;
		this.DOM.spinner.classList.remove('js-hide');
		this.DOM.submitButton.disabled = true;
		this.working = true;
		const formData = new FormData(this.DOM.form);
		formData.append('action', 'custom_cart_submit');
		formData.append('id', this.id);
		formData.append('type', this.type);
		if (this.k) formData.append('k', this.k);

		grecaptcha.ready(() => {
			grecaptcha.execute(RECAPTCHA_SITE_KEY, { action: 'submit' }).then((token: string) => {
				formData.append('g-recaptcha-response', token);
				try {
					fetch(ajaxurl, {
						method: 'POST',
						body: formData,
					}).then(this.formResponse.bind(this));
				} catch (error) {
					console.log(error);
					this.showErrorMessage(String(error));
					this.render();
				}
			});
		});
	}

	render() {
		this.working = false;
		this.DOM.spinner.classList.add('js-hide');
		this.DOM.submitButton.disabled = false;
	}

	async formResponse(res: Response) {
		this.working = false;
		this.DOM.spinner.classList.add('js-hide');
		const data = (await res.json()) as { links?: { shortLink: string }[] };
		if (data?.links) {
			let html;
			if (data.links.length > 1) {
				html = `<p>Your carts are ready. Visit each of the following links to check out.</p>
        <ul>${data.links.map((el) => `<li><a href="${el.shortLink}" target="_blank" rel="noopener noreferrer"><code>${el.shortLink}</code></a></li>`).join('')}</ul><p>Please note that your carts will expire in 24 hours.</p>`;
			} else {
				html = `<p>Your cart is ready. Visit <a href="${data.links[0].shortLink}" target="_blank" rel="noopener noreferrer"><code>${data.links[0].shortLink}</code></a> to check out.</p><p>Please note that your cart will expire in 24 hours.</p>`;
			}
			this.showSuccessMessage(html);
		} else {
			this.showErrorMessage(`Request could not be processed.`);
		}
	}

	showSuccessMessage(message: string) {
		const section = document.createElement('div');
		section.classList.add('section', 'messageSection', 'success');
		const html = `
<div class="sectionHeader">
  <h2 class="sectionHl">Success!</p>
</div>
<div class="sectionBody">
  <div class="formRow">
    <div class="formCol">
      ${message}
    </div>
  </div>
</div>
`;
		section.innerHTML = html;
		this.DOM.form.appendChild(section);
	}

	showErrorMessage(message: string) {
		const section = document.createElement('div');
		section.classList.add('section', 'messageSection', 'error');
		const html = `
<div class="sectionHeader">
  <h2 class="sectionHl">Error</p>
</div>
<div class="sectionBody">
  <div class="formRow">
    <div class="formCol">
      ${message ? `<pre>${message}</pre>` : ''}
      <p><a href="mailto:support@freeflysystems.com">Email support</a> for help.</p>
    </div>
  </div>
</div>
`;
		section.innerHTML = html;
		this.DOM.form.appendChild(section);
	}
}

new FFCustomCart();
